/** CoStar.Api.AptsNet.MobileServices.ViewModels.VerifyIdentity.ManualVerificationStatus */
export var ManualVerificationStatus;
(function (ManualVerificationStatus) {
    ManualVerificationStatus[ManualVerificationStatus["Unknown"] = 0] = "Unknown";
    ManualVerificationStatus[ManualVerificationStatus["FailedByManualDecision"] = 14] = "FailedByManualDecision";
    ManualVerificationStatus[ManualVerificationStatus["PassedByManualDecision"] = 15] = "PassedByManualDecision";
})(ManualVerificationStatus || (ManualVerificationStatus = {}));
/** CoStar.Api.AptsNet.MobileServices.ViewModels.VerifyIdentity.ClientSource */
export var ClientSource;
(function (ClientSource) {
    ClientSource[ClientSource["Unknown"] = 0] = "Unknown";
    ClientSource[ClientSource["Apartments"] = 1] = "Apartments";
    ClientSource[ClientSource["RentalHomesPlus"] = 2] = "RentalHomesPlus";
    ClientSource[ClientSource["MobileApartments"] = 3] = "MobileApartments";
    ClientSource[ClientSource["ApartmentsHomeLiving"] = 5] = "ApartmentsHomeLiving";
    ClientSource[ClientSource["Move"] = 14] = "Move";
    ClientSource[ClientSource["WestsideRentals"] = 15] = "WestsideRentals";
    ClientSource[ClientSource["AndroidApartments"] = 100] = "AndroidApartments";
    ClientSource[ClientSource["IPhoneApartments"] = 101] = "IPhoneApartments";
    ClientSource[ClientSource["IPhoneRHP"] = 102] = "IPhoneRHP";
    ClientSource[ClientSource["AndroidRHP"] = 103] = "AndroidRHP";
    ClientSource[ClientSource["AppsTollFree"] = 104] = "AppsTollFree";
    ClientSource[ClientSource["ApartmentFinder"] = 500] = "ApartmentFinder";
    ClientSource[ClientSource["MobileApartmentFinder"] = 501] = "MobileApartmentFinder";
    ClientSource[ClientSource["IPhoneApartmentFinder"] = 502] = "IPhoneApartmentFinder";
    ClientSource[ClientSource["AndroidApartmentFinder"] = 503] = "AndroidApartmentFinder";
    ClientSource[ClientSource["FinderSite"] = 504] = "FinderSite";
    ClientSource[ClientSource["MobileFinderSite"] = 505] = "MobileFinderSite";
    ClientSource[ClientSource["IPhoneFinderSite"] = 506] = "IPhoneFinderSite";
    ClientSource[ClientSource["AndroidFinderSite"] = 507] = "AndroidFinderSite";
    ClientSource[ClientSource["ForRent"] = 508] = "ForRent";
    ClientSource[ClientSource["Cozy"] = 509] = "Cozy";
})(ClientSource || (ClientSource = {}));
/** CoStar.Api.AptsNet.MobileServices.ViewModels.VerifyIdentity.QuestionType */
export var QuestionType;
(function (QuestionType) {
    QuestionType[QuestionType["Unknown"] = 0] = "Unknown";
    QuestionType[QuestionType["Text"] = 1] = "Text";
    QuestionType[QuestionType["MultipleChoice"] = 2] = "MultipleChoice";
})(QuestionType || (QuestionType = {}));
/** CoStar.Api.AptsNet.MobileServices.ViewModels.VerifyIdentity.IdentityVerificationStatus */
export var IdentityVerificationStatus;
(function (IdentityVerificationStatus) {
    IdentityVerificationStatus[IdentityVerificationStatus["NotFound"] = 0] = "NotFound";
    IdentityVerificationStatus[IdentityVerificationStatus["Pass"] = 1] = "Pass";
    IdentityVerificationStatus[IdentityVerificationStatus["Failed"] = 2] = "Failed";
    IdentityVerificationStatus[IdentityVerificationStatus["PinExam"] = 3] = "PinExam";
    IdentityVerificationStatus[IdentityVerificationStatus["QuestionExam"] = 4] = "QuestionExam";
    IdentityVerificationStatus[IdentityVerificationStatus["Error"] = 5] = "Error";
})(IdentityVerificationStatus || (IdentityVerificationStatus = {}));
